import React, {Component} from 'react'
import withValidation from '../../../../container/withValidation'

import CustomTextField from '../CustomTextField'

class CardHolderNameInput extends Component {

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e) {
        const inputValue = e.target.value.replace(/[^a-zñ ]/gi, "").substring(0, 60).toUpperCase()
        e.target.value = inputValue;
        this.props.onChange(e)
        this.props.validate(inputValue.length > 0)
        this.props.updateCardData({key: 'card_holder_name', value: inputValue});
    }

    render() {
        /* Se agregan estas properties debido a un error que se visualiza en la consola por pasar el restOfProps al CustomTextField 
            ya que no las utiliza, sin embargo son utilizadas por el withValidation */
        const {tabIndex, registerValidation, validateInput, updateCardData, validate, ...restOfProps} = this.props

        return (<CustomTextField
            id="cardHolderName"
            label="Nombre y Apellido del Titular"
            helperText="Como figura en el plástico"
            {...restOfProps}
            name="card_data.card_holder_name"
            onChange={this.handleChange}
            tabIndex={tabIndex}
        />)
    }

}

const validation = (value) => {
    const valid = value.length > 0
    return {
        isValid: valid,
        message: valid ? "" : "Completa este dato"
    }
}

export default withValidation(validation)(CardHolderNameInput)
